<template>
  <!-- Whole component needs a review -->
  <nav class="progress-bar" id="progress-bar" :class="'progress-bar-steps--' + visibleProgressBarPath.length">
    <ol class="progress-bar__list" v-if="activeStageIndex != -1">
      <li
        class="progress-bar__item"
        v-for="(item, index) in visibleProgressBarPath"
        :key="item.stage"
      >
        <span
          class="progress-bar__link progress-bar__link--complete"
          :href="'#' + item.stage"
          v-if="activeStageIndex > index"
        >
          <font-awesome-icon icon="check-circle" />
        </span>
        <span
          class="progress-bar__link progress-bar__link--current"
          v-text="index + 1"
          v-else-if="stage == item.stage"
        ></span>
        <span
          class="progress-bar__link progress-bar__link--future"
          v-text="index + 1"
          v-else
        ></span>
      </li>
    </ol>
  </nav>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: "progress-bar",
  methods: {
    /*
     * 1 - General Admission (GA), paid, no seat allocation or section required
     */
    paidEventNoSeatAllocation() {
      let progressBarStages = [
        { stage: "choose-tickets" },
        { stage: "shopping-cart" },
        { stage: "delivery-details" },
      ];

      return progressBarStages;
    },
    /*
     * 2 - General Admission (GA), paid, no seat allocation, choose section
     */
    paidEventNoSeatAllocationSeatMapRequired() {
      let progressBarStages = [
        { stage: "seating-area" },
        { stage: "choose-tickets" },
        { stage: "shopping-cart" },
        { stage: "delivery-details" },
        { stage: "payment" },
      ];

      return progressBarStages;
    },
    /*
     * 3 - Standard Seat Allocation (SP)
     */
    standardSeatAllocation() {
      let progressBarStages = [
        { stage: "seating-area" },
        { stage: "choose-seats" },
        { stage: "choose-tickets" },
        { stage: "shopping-cart" },
        { stage: "delivery-details" },
        { stage: "payment" },
      ];

      return progressBarStages;
    },
    /*
     * 4 - Best Available (BA), choose & preview two seat selection options on seat-preview
     * 5 - Hot Show (HS), *preview* seat selection on seat-preview
     */
    bestAvailableOrHotShow() {
      let progressBarStages = [
        { stage: "seating-area" },
        { stage: "ticket-quantity" },
        { stage: "seat-preview" },
        { stage: "choose-tickets" },
        { stage: "shopping-cart" },
        { stage: "delivery-details" },
        { stage: "payment" },
      ];

      return progressBarStages;
    },
    registrationPath() {
      let progressBarStages = [
        { stage: "choose-date-time" },
        { stage: "registration-details" },
        { stage: "registration-success" },
      ];

      return progressBarStages;
    },
  },
  computed: {
    onRegistrationPath() {
      // Note is the $route name
      // choose-date-time is both a *component* within the purchase path flow
      // *and* a named route view "registration-choose-date-time" so this will be reached
      return this.$route.name.includes('registration')
    },
    visibleProgressBarPath() {
      let activePath = ""

      // Registration path, therefore show registration flow. 
      if(this.onRegistrationPath && this.error != 'date_times_retrieval_failed') {
        activePath = this.registrationPath();
      } else {
        // In ascending order of stages required
        // need to go through each, as we need to return the greatest of all that are set
        if(this.progressBarPath["paidEventNoSeatAllocation"]) activePath = this.paidEventNoSeatAllocation();
        if(this.progressBarPath["paidEventNoSeatAllocationSeatMapRequired"]) activePath = this.paidEventNoSeatAllocationSeatMapRequired();
        if(this.progressBarPath["standardSeatAllocation"]) activePath = this.standardSeatAllocation();
        if(this.progressBarPath["bestAvailableOrHotShow"]) activePath = this.bestAvailableOrHotShow();
      }
      
      return activePath;
    },
    activeStageIndex() {
      if(this.visibleProgressBarPath == "") {
        return -1;
      } else if(this.$route.name == 'cart-confirmation' || this.$route.name == "registration-success") {
        // Some arbitrarily large number so we exceed the possible stages in the path
        // i.e. so we see the final stages ticked off
        return 100
      } else {
        return this.visibleProgressBarPath.findIndex(
          (item) => item.stage == this.stage
        );
      }
    },
    ...mapState(['progressBarPath', 'stage', 'error'])
  },
};
</script>
